export default "__VITE_ASSET__348190f3__"